const _tableImport = {
    excleHead: [
        // status
        {
            title: "Status Import",
            dataIndex: "status_import",
            scopedSlots: { customRender: "status_import" },
            width: 100,
            // fixed: "left",
            className: "center-colum column-header-fix-data-s",
        },
        // status
        {
            title: "Status Import Detail",
            dataIndex: "status_detail",
            scopedSlots: { customRender: "status_detail" },
            width: 150,
            // fixed: "left",
            // className: "center-colum column-header-fix-data-s",
        },
        {
            title: "Student_ID",
            dataIndex: "student_id",
            key: "student_id",
            width: 80,
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "MUICAA Member",
            dataIndex: "membership_id",
            key: "membership_id",
            width: 80,
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "MUICAA Steering Committee",
            dataIndex: "muicaa_member",
            key: "muicaa_member",
            width: 100,
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },

    ],
}

export default _tableImport;